import clsx from "clsx";
import { useEffect } from "react";
import { createPortal } from "react-dom";
import { useDissociateEmployeeMutation } from "../../../../../../features/peopleApi";
import { addBannerWithTimeout } from "../../../../../lib/centralizedBanner/slice";
import { useAppDispatch } from "../../../../../lib/redux/hooks";
import { colors } from "../../../../../ui/colors";
import { PlusIcon } from "../../../../../ui/icons/plus";
import Button from "../../../../../ui/molecules/button";
import { Spinner } from "../../../../../ui/molecules/spinner";
import { PersonDTO } from "../../../people/dto";

export function DissociateEmployeeModal({ onClose, isOpen, person, navigate, setOpenAssociateModal }: { onClose: () => void; isOpen: boolean; person: PersonDTO; navigate: (section: 'list' | 'new' | 'edit') => void; setOpenAssociateModal: (open: boolean) => void }) {

    useEffect(() => {
        const handleEscKeyPress = (event: KeyboardEvent) => {
            if (event.key === 'Escape') {
                event.preventDefault();
                event.stopPropagation();
                onClose();
            }
        };

        document.addEventListener('keydown', handleEscKeyPress);

        return () => {
            document.removeEventListener('keydown', handleEscKeyPress);
        };
    }, []);

    const dispatch = useAppDispatch();

    const [dissociate, { isLoading: isDissociating }] = useDissociateEmployeeMutation()

    const handleSubmit = async () => {
        try {
            await dissociate({
                data: null,
                personId: person?.id || '',
                oldCompanyId: person.companyId
            }).unwrap();
            navigate('list');
            onClose()
            dispatch(addBannerWithTimeout({
                message: "Contatto dissociato con successo",
                variant: "success"
            }));
        } catch (error) {
            dispatch(addBannerWithTimeout({
                message: "Errore durante la dissociazione del contatto",
                variant: "error"
            }));
        }
    };

    return (
        <>
            {createPortal(
                <div
                    onClick={(e) => {
                        e.preventDefault();
                        e.stopPropagation();
                        onClose();
                    }}
                    className={clsx(
                        "transition-all fixed bg-opacity-30 z-[50] bg-neutral-950 backdrop-blur-sm top-0 left-0 right-0 bottom-0 h-full w-full flex items-center justify-center",
                        {
                            block: isOpen,
                            hidden: !isOpen,
                        }
                    )}
                >
                    <div
                        onClick={(e) => {
                            e.preventDefault();
                            e.stopPropagation();
                        }}
                        className="transition-all relative bg-white rounded-[12px] opacity-100 shadow-sm min-w-[600px]"
                    >
                        <div
                            onClick={() => onClose()}
                            className="absolute cursor-pointer rotate-45 top-[-16px] right-[-16px] border border-brandPrimary-600 h-8 w-8 rounded-full flex items-center justify-center bg-brandPrimary-50"
                        >
                            <PlusIcon color={colors.brandPrimary[600]} size={16} />
                        </div>
                        <div className="p-6 text-heading-xs font-semibold text-center">
                            Dissocia referente da azienda
                        </div>
                        <div className="px-6 py-8 flex flex-col justify-center items-center gap-6 border-t-neutral-200 border-t">
                            <p className="text-text-md font-medium text-neutral-600 text-center max-w-lg">
                                Se sei in possesso delle informazioni necessarie, inseriscile per <span className="font-bold text-neutral-800">associare il referente ad un'altra azienda</span>, altrimenti sarà associato all'azienda temporanea "<span className="font-bold text-neutral-800">Commerciali Digitali</span>"
                                <br />
                                <br />
                            </p>
                            <div className="flex w-full items-center gap-4">
                                {
                                    isDissociating ?
                                        <div className="flex-1 flex items-center justify-center">
                                            <Spinner color="primary" size={32} />
                                        </div> :
                                        <div className="flex-1">
                                            <Button size={"sm"} iconPosition={"left"} variant={"outline"} color={"blue"} label='Associa a "Commerciali Digitali"' onClick={() => handleSubmit()} fullWidth />
                                        </div>
                                }
                                <div className="flex-1">
                                    <Button size={"sm"} iconPosition={"left"} variant={"solid"} color={"blue"} label="Associa a nuova azienda" onClick={() => {
                                        onClose()
                                        setOpenAssociateModal(true)
                                    }}
                                        fullWidth
                                    />
                                </div>
                            </div>
                        </div>
                    </div>
                </div>,
                document.body
            )}
        </>
    )
}